import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-integer";
import "core-js/modules/es6.array.sort";
import _set from "lodash/set";
import _isString from "lodash/isString";
import _isPlainObject from "lodash/isPlainObject";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class provides methods for constructing a Marketplace request payload.
 * Payloads can be built by creating an instance, chaining additional method calls,
 * and calling getPayload() to get the payload object.
 */
export var MarketplacePayloadBuilder =
/*#__PURE__*/
function () {
  function MarketplacePayloadBuilder() {
    _classCallCheck(this, MarketplacePayloadBuilder);

    this.payload = {
      fields: [],
      pagination: {},
      parameters: {},
      query: [],
      sort: []
    };
  }
  /**
   * Setting this 'fields' property limits the response payload to include only the fields set in this fields array.
   * The fields array is empty by default, which means the request will returns all fields
   * that the product owner deems visible by default in the product type's offers / products / institutions schema.
   * @param {Object[]} fields - Marketplace request fields
   * @returns {MarketplacePayloadBuilder} - The MarketplacePayloadBuilder instance.
   */


  _createClass(MarketplacePayloadBuilder, [{
    key: "setFields",
    value: function setFields(fields) {
      if (!Array.isArray(fields)) {
        throw new TypeError('setFields must receive an array as an argument');
      }

      this.payload.fields = fields;
      return this;
    }
    /**
     * Adds a sort object to the sort array.
     * Sorting is done by the order of the sort fields in this array.
     * The order of the items in the response is undefined if no sort order is defined.
     * @param {string} field - field to sort by
     * @param {string} order - sort by 'asc' (ascending) or 'desc' (descending)
     * @returns {MarketplacePayloadBuilder} - The MarketplacePayloadBuilder instance.
     */

  }, {
    key: "addSortField",
    value: function addSortField(_ref) {
      var field = _ref.field,
          order = _ref.order;

      if (!_isString(field) || !_isString(order)) {
        throw new TypeError('addSortField arguments must be strings');
      }

      this.payload.sort.push({
        field: field,
        order: order
      });
      return this;
    }
    /**
     *
     * @param {string} field - The query field
     * @param {string} type - the operator type (e.g. 'eq' for equals)
     * @param {*} value - the value that the field and type should compare against.
     * @returns {MarketplacePayloadBuilder} - The MarketplacePayloadBuilder instance.
     */

  }, {
    key: "setQueryParams",
    value: function setQueryParams(_ref2) {
      var field = _ref2.field,
          type = _ref2.type,
          value = _ref2.value;

      if (!_isString(field) || !_isString(type)) {
        throw new TypeError('setQueryParams argument must be an object with field and type values set to strings');
      }

      this.payload.query.push({
        field: field,
        type: type,
        value: value
      });
      return this;
    }
    /**
     * Set a named query for the payload.
     * @param {string} namedQuery - Named query name
     * @returns {MarketplacePayloadBuilder} - The MarketplacePayloadBuilder instance.
     */

  }, {
    key: "setNamedQuery",
    value: function setNamedQuery(namedQuery) {
      this.payload.named_query = namedQuery;
      return this;
    }
    /**
     * Set the offset and limit for the request.
     * @param {number} offset - offset the results returned by a certain number
     * @param {number} limit - sets the maximum number of items that will be returned, beginning from the offset
     * @returns {MarketplacePayloadBuilder} - The MarketplacePayloadBuilder instance.
     */

  }, {
    key: "setPagination",
    value: function setPagination(_ref3) {
      var offset = _ref3.offset,
          limit = _ref3.limit;

      if (!Number.isInteger(offset) || !Number.isInteger(limit)) {
        throw new TypeError('setPagination argument must be an object with offset and limit set to numbers');
      }

      this.payload.pagination.offset = offset;
      this.payload.pagination.limit = limit;
      return this;
    }
    /**
     * Set the parameters for the request query.
     * @param {Object} parameters - The parameters for the request query
     * @returns {MarketplacePayloadBuilder} - The MarketplacePayloadBuilder instance.
     */

  }, {
    key: "setParameters",
    value: function setParameters(parameters) {
      if (!_isPlainObject(parameters)) {
        throw new TypeError('setParameters argument must be an object');
      }

      _set(this.payload, 'parameters', parameters);

      return this;
    }
    /**
     * Returns the request payload object.
     * @returns {Object} - the request payload object.
     */

  }, {
    key: "getPayload",
    value: function getPayload() {
      return this.payload;
    }
  }]);

  return MarketplacePayloadBuilder;
}();